module.exports = __webpack_public_path__ + "static/media/LockSimpleOpen.d2b241b2.svg";